import { Modal, ModalOverlay, useToast } from '@chakra-ui/react'
import { useStoreActions, useStoreState } from 'easy-peasy'
import React from 'react'
import { SendIntakeModal } from '../../handlers/clinician-calendar/components/event-modals/send-intake-modal'

export const SendIntakeDocumentsModal: React.FC = () => {
  const { isOpen, patientId } = useStoreState(
    (state: any) => state.modals.sendIntakeDocuments
  )
  const { closeModal } = useStoreActions(
    (actions: any) => actions.modals.sendIntakeDocuments
  )
  const { user } = useStoreState((state: any) => state.auth)

  const handleSendDocuments = () => {
    closeModal()
  }

  const handleNotNow = () => {
    closeModal()
  }

  if (!user?.clinic?.id || !patientId) {
    return null
  }

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <SendIntakeModal
        patientId={patientId}
        clinicId={user.clinic.id}
        onClose={closeModal}
        onSendDocuments={handleSendDocuments}
        onNotNow={handleNotNow}
      />
    </Modal>
  )
}
